module.exports = __webpack_public_path__ + "img/reassign.816fa01e.svg";